/**
 * True only in a browser tab on an iPhone (or iPod touch): not the app's
 * WebView, not a Home Screen launch. iPad is excluded on purpose — iPadOS
 * Safari implements the Fullscreen API for elements, and its UA claims to be a
 * Mac anyway, so it never matches `iPhone`.
 */
export function shouldHintIphoneFullscreen(env) {
    if (env.nativeWebView)
        return false;
    if (env.navigatorStandalone === true || env.displayModeStandalone === true)
        return false;
    return /\b(iPhone|iPod)\b/.test(env.userAgent);
}
//# sourceMappingURL=iphone-fullscreen-hint.js.map